<template>
  <div class="column is-one-quarter">
    <div class="card">
      <button class="delete is-small" type="button" @click="media.markForDelete()"></button>
      <div class="card-image">
        <figure class="image">
          <img v-if="preview" :src="preview" />
        </figure>
        <b-progress v-if="progress" :value="progress" show-value format="percent" class="progress"></b-progress>
      </div>
      <div class="card-content">
        <b-input v-model="media.attributes.caption" type="textarea" size="is-small"></b-input>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { imageUrl } from '@/utils/s3'
export default {
  props: {
    media: Object
  },
  data () {
    return {
      preview: null,
      progress: 0
    }
  },
  computed: mapGetters([ 'userBucket' ]),
  mounted () {
    const self = this
    this.media.onProgress = (percent) => this.progress = percent
    this.media.prefix = this.userBucket
    if (this.media.file) {
      const reader = new FileReader()
      reader.onload = e => self.preview = e.target.result
      reader.readAsDataURL(this.media.file)
    } else if (this.media.attributes.key) {
      this.preview = imageUrl(this.media.attributes.key, { resize: { width: 300, height: 200 }})
    }
  }
}
</script>

<style scoped lang="scss">
.card {
  position: relative;
  button.delete {
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 5;
  }
  .card-image .progress {
    position: absolute;
    left: 10%;
    width: 80%;
    top: 50%;
    margin-top: -5px;
    z-index: 1;
  }
}
</style>
